import React from 'react'
import PropTypes from 'prop-types'
import { ToggleTag } from './styled'

const ToggleLink = ({ onClick, show }) => {
    return (
        <ToggleTag href={'#nowhere'} onClick={onClick}>
            [{show ? '-' : '+'}]
        </ToggleTag>
    )
}

ToggleLink.propTypes = {
    onClick: PropTypes.func,
    show: PropTypes.bool,
}

export default ToggleLink
